// const debug = require('debug')('OD::Lib:SecurityHelper')

function findUserInClub(currentUser, clubUsers) {
  if (currentUser) {
    const userArray = clubUsers.find(item => item.id === currentUser.uid)
    return userArray
  }
  return null
}
export default {
  isLoggedUser(currentUser) {
    return currentUser !== null
  },
  isSuperAdminUser(currentUser) {
    return currentUser !== null && currentUser.superadmin
  },
  isClubAdmin(currentUser, clubUsers, clubId) {
    const user = findUserInClub(currentUser, clubUsers)
    if (clubUsers && currentUser && user) {
      return user.role === 'admin'
    }
    return false
  },
  isClubEditor(currentUser, clubUsers, clubId) {
    const user = findUserInClub(currentUser, clubUsers)
    if (clubUsers && currentUser && user) {
      return user.role === 'editor'
    }
    return false
  },
  isClubViewer(currentUser, clubUsers, clubId) {
    const user = findUserInClub(currentUser, clubUsers)
    if (clubUsers && currentUser && user) {
      return user.role === 'viewer'
    }
    return false
  },
}
